import type { ProductListItem } from 'types/capi/shared';

import {
  type ContractStockStatus,
  toContractStockStatus
} from '~/domain/stockStatus';

import type { ImageGridDisplayType } from './EditorialImageImpressionEvent';
import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

const NO_PRICE = -1;
const PRODUCT_CARD_SCHEMA_VERSION = 2;

export type ProductCardDisplayType = 'block' | 'carousel' | 'grid';

export type ProductCardInteractionDisplayType =
  | ImageGridDisplayType
  | ProductCardDisplayType;

export type ProductCardTargetProperties = {
  display_type?: ProductCardInteractionDisplayType;
  module_position?: number;
  module_type: string;
  position: number;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  product_id: string;
  retailer_id?: string;
  search_term?: string;
  stock_status: ContractStockStatus;
};

type EventData = {
  displayType?: ProductCardInteractionDisplayType;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType: string;
  position: number;
  product: Pick<ProductListItem, 'id' | 'price' | 'stock_status'>;
  retailerId?: string;
  searchTerm?: string;
};

class ProductCardInteractionEvent extends InteractionEvent<
  EventData,
  ProductCardTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'product_card';
  }

  protected get schemaVersion(): number {
    return PRODUCT_CARD_SCHEMA_VERSION;
  }

  protected getTargetProperties(): ProductCardTargetProperties {
    return {
      display_type: this.data.displayType,
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      position: this.data.position,
      price_currency: this.data.product.price.currency,
      price_regular: this.data.product.price.regular ?? NO_PRICE,
      price_sale: this.data.product.price.sale ?? undefined,
      product_id: String(this.data.product.id),
      retailer_id: this.data.retailerId,
      search_term: this.data.searchTerm,
      stock_status: toContractStockStatus(this.data.product.stock_status)
    };
  }
}

export default ProductCardInteractionEvent;
